import React from 'react';
import { Radio } from 'antd';

const ConversionMenu = ({ value, onChange }) => (
  <Radio.Group
    defaultValue="NONE"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    buttonStyle="solid"
    style={{ marginLeft: 1 }}
  >
    <p
      style={{
        fontSize: 16,
        marginBottom: 0,
        marginLeft: 15,
        textAlign: 'left',
      }}
    >
      Conversion over time:
    </p>
    <Radio.Button value="NONE">None</Radio.Button>
    <Radio.Button value="DAY">Daily</Radio.Button>
    <Radio.Button value="WEEK">Weekly</Radio.Button>
    <Radio.Button value="MONTH">Monthly</Radio.Button>
  </Radio.Group>
);

export default ConversionMenu;
